var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 63,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m20.944 18.655 27.454 3.629M19.72 27.908l13.727 1.814m-30.357.726c-.652 4.935 2.205 9.687 6.942 11.044q5.063 1.454 10.287 2.55a3.5 3.5 0 0 1 2.434 1.894l6.718 13.858 10.09-11.636a3.5 3.5 0 0 1 1.285-.93 3.5 3.5 0 0 1 1.557-.267c3.528.198 7.063.269 10.596.211 4.927-.08 8.92-3.923 9.574-8.864l2.454-18.561c.653-4.941-2.205-9.69-6.942-11.048a147 147 0 0 0-21.274-4.422 147 147 0 0 0-21.693-1.258c-4.927.08-8.921 3.927-9.574 8.865l-2.454 18.56z"
  })));
};
export default SvgChat;